import React from 'react';
import { useSelector } from 'react-redux';

import { FILTER_PRICE } from 'dpl/constants/query_params';
import { LEARNING_CENTER_PRICE_PATH } from 'dpl/shared/constants/urls';
import { beginsWithVowel } from 'dpl/shared/utils';
import SmartLink from 'dpl/components/SmartLink';

import MultiSelectChecklistFilter from './MultiSelectChecklistFilter';

export default function PriceFilter() {
  const { puppyPriceRanges, breedName, medianBreedPrice } = useSelector(
    ({ server }) => server
  );

  return (
    <>
      {/*
          Calculating average price can be inaccurate due to pricing outliers. Using a
          calculated median price based off breed's litter price range low/high values instead.
        */}
      <MultiSelectChecklistFilter
        filterTitle="Price"
        filterSubtitle={
          Boolean(medianBreedPrice) && (
            <>
              The average price of {beginsWithVowel(breedName) ? 'an' : 'a'}{' '}
              {breedName} puppy is {medianBreedPrice}.{' '}
              <SmartLink
                className="underline"
                to={LEARNING_CENTER_PRICE_PATH}
                target="_blank"
              >
                Learn more
              </SmartLink>
            </>
          )
        }
        filterParam={FILTER_PRICE}
        filterOptions={puppyPriceRanges}
      />
    </>
  );
}
